import styled from "styled-components";

export default styled.div<{ styles: any }>`
    ${(props: any) => props.styles}
`;
